module.exports = "<h2 class=\"dash-header\" hide-xs>\n  <span>Daily Roster</span>\n</h2>\n\n<span flex></span>"